<template>
    <div class="financeApplication__form__row">
        <label :for="id" v-if="id && label" class="financeApplication__form__row__label" :class="{ 'sr-only': isLabelScreenReaderOnly }">{{ label }}</label>
        <slot />
        <div class="financeApplication__form__validationMessage" v-if="errorMessage">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },
        label: {
            type: String
        },
        isLabelScreenReaderOnly: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String
        }
    }
}
</script>